import React from 'react';
import MailDark from '../../../assets/icons/mail-dark.svg';

const ImpulseMessage = ({message}) => {
    if (!message) {
        return null;
    }

    return (
        <div className='checkout-content__message display-flex block-width align-items-center justify-content-center background-color-gray-50'>
            <div>
                <MailDark className='display-block'/>
            </div>
            <p className='text-md color-gray-600 padding-left-0dot75rem'>{message}</p>
        </div>
    )
};

export default React.memo(ImpulseMessage);
